/**
 * ============================================================================
 * GENERATED FILE - Created via: pnpm run generate:wetags
 * ============================================================================
 *
 * This file was generated by the wetag library generator.
 *
 * To add new entity types or update configuration, run:
 *   pnpm run generate:wetags
 *
 * You can safely modify this file if needed, but using the generator
 * ensures consistency across all wetag libraries in the codebase.
 *
 * To add type-safe tag names, update the tags.ts file in this directory.
 * ============================================================================
 */

import { usePhoneSettingsStore } from '@frontend/phone-config';
import {
  createNamespacedWetagHooks,
  createNamespacedWetagHooksForOrg,
  createNamespacedWetagHooksForUser,
} from '@frontend/wetags';
import type { PhoneConfigTags } from './tags';

const PHONE_CONFIG_NAMESPACE = 'phone-config';

export const PhoneConfigOrg = createNamespacedWetagHooksForOrg<PhoneConfigTags>(PHONE_CONFIG_NAMESPACE);
export const PhoneConfigUser = createNamespacedWetagHooksForUser<PhoneConfigTags>(PHONE_CONFIG_NAMESPACE);

const useCurrentPhoneTenantId = () => usePhoneSettingsStore((state) => state.settingsTenantLocation?.phoneTenantId);
const getCurrentPhoneTenantId = () => usePhoneSettingsStore.getState().settingsTenantLocation?.phoneTenantId;

// Resolves the wetag entity by the selected settings tenant instead of org, for tenant-scoped phone features.
export const PhoneConfigTenant = createNamespacedWetagHooks<PhoneConfigTags>(
  PHONE_CONFIG_NAMESPACE,
  useCurrentPhoneTenantId,
  getCurrentPhoneTenantId
);
